import React, { useContext } from 'react'

import TileLink from '../TileLink'
import TileLinkWrapper from '../TileLinkWrapper'
import PassPageContext from '../PassPageContext'

// interface DocBranchProps {
//   data: DocsIndexQueryQuery
//   categoryFilter: string
//   slug: string
//   location: Location
// }

function GenerateDocsIndex(props: { filter: string }) {
  const pageContext = useContext<any>(PassPageContext) // TODO: type this context

  const slug = pageContext?.slug

  if (!slug) {
    return 'Page slug is not in the pageContext'
  }

  const docsIndexData = (pageContext.docsIndex ?? []) as {
    iconSrc: string
    title: string
    link: string
    description: string
    category: string
  }[]

  return (
    <TileLinkWrapper>
      {docsIndexData
        .filter(({ category }) =>
          props.filter ? category === props.filter : true,
        )
        .map(({ iconSrc, title, link, description }) => (
          <TileLink icon={iconSrc} heading={title} to={link} key={link}>
            {description}
          </TileLink>
        ))}
    </TileLinkWrapper>
  )
}

export default GenerateDocsIndex
